import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function Material() {
  const auth = useAuth() || {}; const user = auth.user;
  const isAdmin = user?.role === 'admin';
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [korrektur, setKorrektur] = useState(null);
  const [journal, setJournal] = useState(null);
  const [filter, setFilter] = useState('');

  const load = () => api.get('/material').then(r => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([]));
  useEffect(() => { let m = true; api.get('/material').then(r => { if (m) setItems(Array.isArray(r.data) ? r.data : []); }).catch(() => { if (m) setItems([]); }); return () => { m = false; }; }, []);

  const filtered = items.filter(m =>
    !filter || m.bezeichnung?.toLowerCase().includes(filter.toLowerCase()) || m.pos_nr?.includes(filter)
  );

  const save = async (data) => {
    if (editing?.id) {
      // M3: bestand gehoert nicht mehr in den PUT - der Server ignoriert ihn
      // ohnehin, Aenderungen laufen nur noch ueber die Bestandskorrektur.
      const { bestand, ...stammdaten } = data;
      await api.put(`/material/${editing.id}`, stammdaten);
    } else {
      await api.post('/material', data);
    }
    setShowForm(false); setEditing(null);
    load();
  };

  const remove = async (id) => {
    if (!window.confirm('Wirklich löschen?')) return;
    await api.delete(`/material/${id}`);
    load();
  };

  const importStandard = async () => {
    if (!window.confirm('Standard-Positionen importieren?')) return;
    await api.post('/material/import-standard');
    load();
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Material</div>
          <div className="page-sub">{items.length} Positionen · {items.filter(m => m.bestand <= m.mindestbestand && m.mindestbestand > 0).length} unter Mindestbestand</div>
        </div>
        {isAdmin && (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {items.length === 0 && <button className="btn btn-secondary" onClick={importStandard}>📦 Standard importieren</button>}
            <button className="btn btn-primary" onClick={() => { setEditing({}); setShowForm(true); }}>+ Neue Position</button>
          </div>
        )}
      </div>

      <div className="card">
        <div className="card-head">
          <input className="form-input" placeholder="🔍 Suchen…" value={filter} onChange={e => setFilter(e.target.value)} style={{ maxWidth: 280 }} />
        </div>
        {filtered.length === 0 ? (
          <div className="empty"><div className="empty-icon">📦</div><h3>Kein Material</h3><p>{isAdmin ? 'Oben Position hinzufügen oder Standard importieren' : ''}</p></div>
        ) : (
          <div className="table-wrap table-mobile-stack">
            <table>
              <thead>
                <tr>
                  <th>Pos.-Nr.</th><th>Bezeichnung</th><th>Einh.</th>
                  <th>Bestand</th><th>Mind.</th><th>Status</th>
                  {isAdmin && <th></th>}
                </tr>
              </thead>
              <tbody>
                {filtered.map(m => {
                  const warn = m.bestand <= m.mindestbestand && m.mindestbestand > 0;
                  return (
                    <tr key={m.id}>
                      <td data-label="Pos.-Nr." className="text-mono text-copper" style={{ fontWeight: 600 }}>{m.pos_nr}</td>
                      <td data-label="" className="td-title" style={{ fontWeight: 500 }}>{m.bezeichnung}</td>
                      <td data-label="Einh." style={{ textAlign: 'center' }}>{m.einheit}</td>
                      <td data-label="Bestand" className="text-mono" style={{ fontWeight: 600 }}>{m.bestand}</td>
                      <td data-label="Mind." className="text-mono">{m.mindestbestand}</td>
                      <td data-label="Status">{warn ? <span className="badge badge-red">Nachbestellen</span> : <span className="badge badge-green">OK</span>}</td>
                      {isAdmin && (
                        <td data-label="" className="td-actions">
                          <button className="btn btn-secondary btn-sm" onClick={() => { setEditing(m); setShowForm(true); }}>✏️</button>
                          <button className="btn btn-secondary btn-sm" title="Bestand korrigieren (Bewegungsart wählen)" onClick={() => setKorrektur(m)}>⚖️</button>
                          <button className="btn btn-secondary btn-sm" title="Journal / Bestands-Historie" onClick={() => setJournal(m)}>📜</button>
                          <button className="btn btn-danger btn-sm" onClick={() => remove(m.id)}>🗑</button>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showForm && <MaterialForm item={editing} onClose={() => { setShowForm(false); setEditing(null); }} onSave={save} />}
      {korrektur && <KorrekturModal item={korrektur} onClose={() => setKorrektur(null)} onDone={() => { setKorrektur(null); load(); }} />}
      {journal && <JournalModal item={journal} onClose={() => setJournal(null)} />}
    </div>
  );
}

function MaterialForm({ item, onClose, onSave }) {
  const [data, setData] = useState({
    pos_nr: item.pos_nr || '',
    bezeichnung: item.bezeichnung || '',
    einheit: item.einheit || 'Stück',
    bestand: item.bestand || 0,
    mindestbestand: item.mindestbestand || 0,
    notizen: item.notizen || '',
  });

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 20 }} onClick={onClose}>
      <div className="card" style={{ maxWidth: 500, width: '100%', margin: 0 }} onClick={e => e.stopPropagation()}>
        <div className="card-title" style={{ marginBottom: 14 }}>{item.id ? 'Position bearbeiten' : 'Neue Position'}</div>
        <div className="form-group" style={{ marginBottom: 10 }}><label className="form-label">Pos.-Nr.</label><input className="form-input" value={data.pos_nr} onChange={e => setData({...data, pos_nr: e.target.value})} /></div>
        <div className="form-group" style={{ marginBottom: 10 }}><label className="form-label">Bezeichnung</label><input className="form-input" value={data.bezeichnung} onChange={e => setData({...data, bezeichnung: e.target.value})} required /></div>
        <div className="form-grid form-grid-3" style={{ marginBottom: 10 }}>
          <div className="form-group"><label className="form-label">Einheit</label><input className="form-input" value={data.einheit} onChange={e => setData({...data, einheit: e.target.value})} /></div>
          {/* M3: Bestand nur bei Neuanlage editierbar (wird zur 'anlage'-
              Journal-Buchung). Im Edit read-only - Aenderungen laufen
              ausschliesslich ueber die Bestandskorrektur (mit Bewegungsart). */}
          <div className="form-group">
            <label className="form-label">Bestand</label>
            <input className="form-input" type="number" step="0.01" value={data.bestand}
              readOnly={!!item.id} disabled={!!item.id}
              title={item.id ? 'Änderung nur über „⚖️ Bestand korrigieren“ in der Liste' : undefined}
              onChange={e => setData({...data, bestand: e.target.value})} />
          </div>
          <div className="form-group"><label className="form-label">Mindest.</label><input className="form-input" type="number" step="0.01" value={data.mindestbestand} onChange={e => setData({...data, mindestbestand: e.target.value})} /></div>
        </div>
        {item.id && (
          <div style={{ fontSize: 12, color: 'var(--text-dim, #888)', marginBottom: 10 }}>
            ⚖️ Bestand wird hier nicht mehr geändert — nutze „Bestand korrigieren" in der Liste (mit Begründung, landet im Journal).
          </div>
        )}
        <div className="form-group" style={{ marginBottom: 14 }}><label className="form-label">Notizen</label><textarea className="form-textarea" value={data.notizen} onChange={e => setData({...data, notizen: e.target.value})} /></div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary" onClick={onClose}>Abbrechen</button>
          <button className="btn btn-primary" onClick={() => onSave(data)}>Speichern</button>
        </div>
      </div>
    </div>
  );
}

// M3.2/M3.4: manuelle Bestandskorrektur — einziger Weg, den Bestand manuell
// zu ändern. Eingabe als ZIELbestand („gezählt: 80"), Grund ist Pflicht; die
// Bewegungsart (typ, Default inventur) ist wählbar. Der Server bucht die
// Differenz als Journal-Zeile mit dem gewählten typ (POST /:id/korrektur).
function KorrekturModal({ item, onClose, onDone }) {
  const [bestandNeu, setBestandNeu] = useState('');
  const [typ, setTyp] = useState('inventur');
  const [grund, setGrund] = useState('');
  const [fehler, setFehler] = useState('');
  const [saving, setSaving] = useState(false);

  const art = KORREKTUR_ARTEN.find(a => a.typ === typ) || KORREKTUR_ARTEN[0];

  const aktuell = Number(item.bestand) || 0;
  const neuNum = bestandNeu.trim() === '' ? null : Number(bestandNeu);
  const delta = neuNum === null || !Number.isFinite(neuNum)
    ? null
    : Math.round((neuNum - aktuell) * 100) / 100;
  const fmt = (n) => String(n).replace('.', ',');
  const kannSpeichern = delta !== null && delta !== 0 && grund.trim() !== '' && !saving;

  const speichern = async () => {
    setSaving(true); setFehler('');
    try {
      await api.post(`/material/${item.id}/korrektur`, { bestand_neu: neuNum, grund: grund.trim(), typ });
      onDone();
    } catch (e) {
      setFehler(e.response?.data?.error || 'Korrektur fehlgeschlagen');
      setSaving(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 20 }} onClick={onClose}>
      <div className="card" style={{ maxWidth: 500, width: '100%', margin: 0 }} onClick={e => e.stopPropagation()}>
        <div className="card-title" style={{ marginBottom: 4 }}>⚖️ Bestand korrigieren</div>
        <div style={{ fontSize: 13, marginBottom: 14 }}>
          {item.bezeichnung} <span style={{ opacity: 0.7 }}>· aktueller Bestand: <b className="text-mono">{fmt(aktuell)}</b> {item.einheit}</span>
        </div>

        <div className="form-group" style={{ marginBottom: 10 }}>
          <label className="form-label">Bewegungsart *</label>
          <select className="form-input" value={typ} onChange={e => setTyp(e.target.value)}>
            {KORREKTUR_ARTEN.map(a => <option key={a.typ} value={a.typ}>{a.label}</option>)}
          </select>
        </div>

        <div className="form-group" style={{ marginBottom: 10 }}>
          <label className="form-label">Neuer Bestand (gezählt) *</label>
          <input className="form-input" type="number" step="0.01" value={bestandNeu}
            onChange={e => setBestandNeu(e.target.value)} autoFocus />
        </div>

        {delta !== null && (
          <div style={{ fontSize: 13, marginBottom: 10 }}>
            {delta === 0 ? (
              <span style={{ opacity: 0.7 }}>Keine Änderung — Zielbestand entspricht dem aktuellen Bestand.</span>
            ) : (
              <span>
                {fmt(aktuell)} → {fmt(neuNum)} =&nbsp;
                <b style={{ color: delta > 0 ? 'var(--green, #2e9e5b)' : 'var(--red, #d64545)' }}>
                  {delta > 0 ? '+' : ''}{fmt(delta)} {item.einheit} {delta > 0 ? 'Zugang' : 'Abgang'}
                </b>
              </span>
            )}
          </div>
        )}

        <div className="form-group" style={{ marginBottom: 14 }}>
          <label className="form-label">Grund * (landet im Journal)</label>
          <textarea className="form-textarea" value={grund} placeholder={art.placeholder}
            onChange={e => setGrund(e.target.value)} />
        </div>

        {fehler && <div style={{ color: 'var(--red, #d64545)', fontSize: 13, marginBottom: 10 }}>{fehler}</div>}

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary" onClick={onClose} disabled={saving}>Abbrechen</button>
          <button className="btn btn-primary" onClick={speichern} disabled={!kannSpeichern}>
            {saving ? 'Speichert…' : 'Korrektur buchen'}
          </button>
        </div>
      </div>
    </div>
  );
}

// M3.3: Journal / Bestands-Historie (material_bewegungen aus M3.1).
// Semantik der Spalte "Bestand nach Vorgang": mehrere Zeilen desselben
// BT-Saves tragen bewusst denselben Wert (Netto-Diff, Codex C aus M3-Plan).
const JOURNAL_SEITE = 50;
const TYP_BADGES = {
  anfangsbestand: { label: 'Journal-Start', cls: 'badge-grey' },
  anlage:         { label: 'Anlage', cls: 'badge-green' },
  inventur:       { label: 'Inventur', cls: 'badge-amber' },
  bt_manuell:     { label: 'Bautagebuch', cls: 'badge-copper' },
  bt_auto:        { label: '⚙ automatisch', cls: 'badge-blue' },
  bt_geloescht:   { label: 'BT gelöscht', cls: 'badge-red' },
  // M3.4: manuelle Bewegungsarten
  wareneingang:   { label: 'Wareneingang', cls: 'badge-green' },
  schwund:        { label: 'Schwund / Verlust', cls: 'badge-red' },
  rueckgabe:      { label: 'Rückgabe', cls: 'badge-blue' },
  sonstiges:      { label: 'Sonstige Korrektur', cls: 'badge-grey' },
};

// M3.4: waehlbare Bewegungsarten der Korrektur (Reihenfolge = Dropdown).
// Muss zu KORREKTUR_TYPEN im Backend passen. placeholder hilft beim Grund.
const KORREKTUR_ARTEN = [
  { typ: 'inventur',     label: 'Inventur / Zählkorrektur',   placeholder: 'z. B. Inventur 07/2026, Zählung Lager' },
  { typ: 'wareneingang', label: 'Wareneingang / Bestellung',  placeholder: 'z. B. Lieferschein-Nr. 4711, Lieferant Meier' },
  { typ: 'schwund',      label: 'Schwund / Verlust / Defekt', placeholder: 'z. B. Bruch beim Transport, defekt entsorgt' },
  { typ: 'rueckgabe',    label: 'Rückgabe / Rücklagerung',    placeholder: 'z. B. Rücklagerung von Baustelle X' },
  { typ: 'sonstiges',    label: 'Sonstige Korrektur',         placeholder: 'Bitte Grund beschreiben' },
];

// J-Export: laedt SheetJS bei Bedarf per <script>-Tag und liefert window.XLSX.
// Bewusste Mini-Duplikation von loadXLSX aus BaustellenAuswertung.js (dort
// nicht exportiert; Import aus einem Page-Modul waere unsauber, ein
// lib/-Refactor sprengt den Ein-Datei-Scope dieser Phase). Gleiche CDN-Pin
// + data-xlsx-cdn-Dedup, damit beide Stellen dasselbe Skript teilen.
function loadXLSX() {
  return new Promise((resolve, reject) => {
    if (window.XLSX) return resolve(window.XLSX);
    const existing = document.querySelector('script[data-xlsx-cdn]');
    if (existing) {
      existing.addEventListener('load', () => window.XLSX ? resolve(window.XLSX) : reject(new Error('XLSX nicht verfügbar')));
      existing.addEventListener('error', () => reject(new Error('XLSX-Skript konnte nicht geladen werden')));
      return;
    }
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/xlsx@0.18.5/dist/xlsx.full.min.js';
    s.async = true;
    s.dataset.xlsxCdn = '1';
    s.onload = () => window.XLSX ? resolve(window.XLSX) : reject(new Error('XLSX nicht verfügbar'));
    s.onerror = () => reject(new Error('XLSX-Skript konnte nicht geladen werden'));
    document.head.appendChild(s);
  });
}

function JournalModal({ item, onClose }) {
  const [bewegungen, setBewegungen] = useState([]);
  const [total, setTotal] = useState(0);
  const [laden, setLaden] = useState(true);
  const [exportiert, setExportiert] = useState(false);
  const [fehler, setFehler] = useState('');

  const holen = async (offset) => {
    setLaden(true); setFehler('');
    try {
      const r = await api.get(`/material/${item.id}/bewegungen?limit=${JOURNAL_SEITE}&offset=${offset}`);
      const neu = Array.isArray(r.data?.bewegungen) ? r.data.bewegungen : [];
      setBewegungen((prev) => offset === 0 ? neu : [...prev, ...neu]);
      setTotal(r.data?.total || 0);
    } catch (e) {
      setFehler(e.response?.data?.error || 'Journal konnte nicht geladen werden');
    }
    setLaden(false);
  };
  useEffect(() => {
    holen(0);
    // eslint-disable-next-line
  }, [item.id]);

  const fmtNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? String(n).replace('.', ',') : String(v ?? '–');
  };
  // created_at ist ein echter TIMESTAMPTZ-Zeitpunkt - Date-Parsing ist hier
  // korrekt (kein DATE-Spalten-UTC-Shift), Anzeige in Betrachter-Ortszeit.
  const fmtZeit = (v) => {
    const d = new Date(v);
    return isNaN(d.getTime()) ? '–' : d.toLocaleString('de-DE', {
      day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit',
    });
  };
  const mehrDa = bewegungen.length < total;

  // J-Export: kompletter Journal-Export als .xlsx. Frischer Seiten-Loop
  // gegen die Route (konsistenter Snapshot statt State-Recycling); Route
  // liefert DESC -> Export chronologisch AUFSTEIGEND (Journal-Start zuerst,
  // "Bestand nach Vorgang" ergibt top-down eine nachvollziehbare Lauflinie;
  // User-Entscheidung 20.07.2026 - die Modal-Anzeige bleibt absteigend).
  const exportExcel = async () => {
    setExportiert(true); setFehler('');
    try {
      const XLSX = await loadXLSX();
      const alle = [];
      // Harte Obergrenze (200 Seiten = 10.000 Zeilen) gegen Endlos-Loop,
      // falls total pathologisch waechst.
      for (let i = 0; i < 200; i++) {
        const r = await api.get(`/material/${item.id}/bewegungen?limit=${JOURNAL_SEITE}&offset=${alle.length}`);
        const seite = Array.isArray(r.data?.bewegungen) ? r.data.bewegungen : [];
        alle.push(...seite);
        if (seite.length === 0 || alle.length >= (r.data?.total || 0)) break;
      }
      alle.reverse();

      const typLabel = (t) => (TYP_BADGES[t] || { label: t }).label;
      const zahl = (v) => { const n = parseFloat(v); return Number.isFinite(n) ? n : ''; };
      const jetzt = new Date();
      const aoa = [
        [`Material-Journal: ${item.bezeichnung}${item.pos_nr ? ` (${item.pos_nr})` : ''} · Einheit ${item.einheit || '–'}`],
        [`Aktueller Bestand: ${fmtNum(item.bestand)} ${item.einheit || ''}`.trim()],
        [`Exportiert am: ${jetzt.toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}`],
        [`Bewegungen: ${alle.length}`],
        [],
        ['Zeit', 'Typ', 'Menge', 'Bestand nach Vorgang', 'Kontext', 'Grund', 'Wer'],
        ...alle.map((b) => [
          fmtZeit(b.created_at), typLabel(b.typ),
          zahl(b.menge), zahl(b.bestand_nachher),
          b.kontext || '', b.grund || '', b.user_name || '',
        ]),
      ];
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      ws['!cols'] = [{ wch: 16 }, { wch: 18 }, { wch: 10 }, { wch: 18 }, { wch: 40 }, { wch: 32 }, { wch: 16 }];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Journal');
      const slug = String(item.bezeichnung || 'material').replace(/[^a-z0-9]/gi, '_').substring(0, 30);
      const datum = `${jetzt.getFullYear()}-${String(jetzt.getMonth() + 1).padStart(2, '0')}-${String(jetzt.getDate()).padStart(2, '0')}`;
      XLSX.writeFile(wb, `material-journal-${slug}-${datum}.xlsx`);
    } catch (e) {
      setFehler(e.response?.data?.error || e.message || 'Export fehlgeschlagen');
    }
    setExportiert(false);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 20 }} onClick={onClose}>
      <div className="card" style={{ maxWidth: 760, width: '100%', margin: 0, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div className="card-title" style={{ marginBottom: 4 }}>📜 Journal · {item.bezeichnung}</div>
        <div style={{ fontSize: 13, opacity: 0.75, marginBottom: 14 }}>
          Bestands-Historie · aktueller Bestand: <b className="text-mono">{fmtNum(item.bestand)}</b> {item.einheit}
        </div>

        {fehler && <div style={{ color: 'var(--red, #d64545)', fontSize: 13, marginBottom: 10 }}>{fehler}</div>}

        {!fehler && bewegungen.length === 0 && !laden && (
          <div className="empty" style={{ padding: 20 }}>
            <div className="empty-icon">📜</div>
            <p>Noch keine Bewegungen — das Journal beginnt mit der ersten Bestandsänderung.</p>
          </div>
        )}

        {bewegungen.length > 0 && (
          <div className="table-wrap table-mobile-stack">
            <table>
              <thead>
                <tr>
                  <th>Zeit</th><th>Typ</th><th>Menge</th>
                  <th>Bestand nach Vorgang</th><th>Kontext</th><th>Grund</th><th>Wer</th>
                </tr>
              </thead>
              <tbody>
                {bewegungen.map((b) => {
                  const badge = TYP_BADGES[b.typ] || { label: b.typ, cls: 'badge-grey' };
                  const menge = Number(b.menge);
                  return (
                    <tr key={b.id}>
                      <td data-label="Zeit" className="text-mono" style={{ whiteSpace: 'nowrap' }}>{fmtZeit(b.created_at)}</td>
                      <td data-label="Typ"><span className={`badge ${badge.cls}`}>{badge.label}</span></td>
                      <td data-label="Menge" className="text-mono" style={{ fontWeight: 600, whiteSpace: 'nowrap', color: menge > 0 ? 'var(--green, #2e9e5b)' : 'var(--red, #d64545)' }}>
                        {menge > 0 ? '+' : ''}{fmtNum(b.menge)}
                      </td>
                      <td data-label="Bestand nach Vorgang" className="text-mono">{fmtNum(b.bestand_nachher)}</td>
                      <td data-label="Kontext" style={{ fontSize: 12 }}>{b.kontext || '–'}</td>
                      <td data-label="Grund" style={{ fontSize: 12 }}>{b.grund || '–'}</td>
                      <td data-label="Wer" style={{ fontSize: 12 }}>{b.user_name || '–'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', alignItems: 'center', marginTop: 14 }}>
          <span style={{ fontSize: 12, opacity: 0.7 }}>
            {laden ? 'Lädt…' : `${bewegungen.length} von ${total} Bewegungen`}
          </span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-secondary" onClick={exportExcel} disabled={laden || exportiert || total === 0} title="Komplettes Journal als Excel exportieren">
              {exportiert ? 'Exportiert…' : '⬇ Excel'}
            </button>
            <button className="btn btn-secondary" onClick={() => holen(bewegungen.length)} disabled={laden || !mehrDa}>
              Mehr laden
            </button>
            <button className="btn btn-primary" onClick={onClose}>Schließen</button>
          </div>
        </div>
      </div>
    </div>
  );
}
